module.exports = __webpack_public_path__ + "static/media/7.fc7ac162.jpg";